import React, { useState } from 'react';
import { 
  FaSearch, 
  FaArrowLeft, 
  FaArrowRight, 
  FaTimes, 
  FaDownload,
  FaShareAlt,
  FaHeart,
  FaFilter,
  FaImages,
  FaUserMd,
  FaHome,
  FaAmbulance,
  FaHandsHelping
} from 'react-icons/fa';

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [favorites, setFavorites] = useState(new Set());

  // Gallery data - Replace with actual images
  const galleryImages = [
    // Service Images
    { 
      id: 1, 
      url: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=800&q=80', 
      title: 'Home Nursing Care', 
      category: 'services',
      description: 'Our trained nurses providing professional care at patient homes',
      date: '2024-02-15',
      tags: ['nursing', 'home-care', 'medical']
    },
    { 
      id: 2, 
      url: 'https://www.vestaeldercare.com/wp-content/uploads/2024/03/companionship.jpg', 
      title: 'Elderly Companionship', 
      category: 'services',
      description: 'Compassionate care and companionship for senior citizens',
      date: '2024-02-10',
      tags: ['elderly', 'companionship', 'care']
    },
    { 
      id: 3, 
      url: 'https://images.unsplash.com/photo-1551601651-2a8555f1a136?w-800&q=80', 
      title: 'Physiotherapy Session', 
      category: 'services',
      description: 'Professional physiotherapy at home for recovery and rehabilitation',
      date: '2024-02-05',
      tags: ['physiotherapy', 'rehabilitation', 'therapy']
    },
    { 
      id: 4, 
      url: 'https://images.unsplash.com/photo-1582750433449-648ed127bb54?w-800&q=80', 
      title: 'Doctor Home Visit', 
      category: 'services',
      description: 'Qualified doctors providing consultations at patient homes',
      date: '2024-01-28',
      tags: ['doctor', 'consultation', 'home-visit']
    },
    { 
      id: 5, 
      url: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?w-800&q=80', 
      title: 'Medical Equipment', 
      category: 'equipment',
      description: 'High-quality medical equipment available for rental',
      date: '2024-01-20',
      tags: ['equipment', 'rental', 'medical-devices']
    },
    { 
      id: 6, 
      url: 'https://images.unsplash.com/photo-1551601651-2a8555f1a136?w-800&q=80', 
      title: 'Ambulance Service', 
      category: 'services',
      description: '24/7 ambulance support with trained paramedics',
      date: '2024-01-15',
      tags: ['ambulance', 'emergency', 'transport']
    },
    
    // Team Images
    { 
      id: 7, 
      url: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w-800&q=80', 
      title: 'Our Nursing Team', 
      category: 'team',
      description: 'Certified and experienced nursing professionals',
      date: '2024-01-10',
      tags: ['team', 'nurses', 'professionals']
    },
    { 
      id: 8, 
      url: 'https://images.unsplash.com/photo-1582750433449-648ed127bb54?w-800&q=80', 
      title: 'Medical Director', 
      category: 'team',
      description: 'Dr. Rajesh Verma, Medical Director - 15+ years experience',
      date: '2024-01-05',
      tags: ['doctor', 'leadership', 'medical-director']
    },
    { 
      id: 9, 
      url: 'https://images.unsplash.com/photo-1551601651-2a8555f1a136?w-800&q=80', 
      title: 'Caregivers Training', 
      category: 'team',
      description: 'Regular training sessions for our caregiving team',
      date: '2024-01-02',
      tags: ['training', 'caregivers', 'professional-development']
    },
    
    // Facility Images
    { 
      id: 10, 
      url: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w-800&q=80', 
      title: 'Medical Equipment Storage', 
      category: 'facility',
      description: 'Sterilized and well-maintained medical equipment storage',
      date: '2023-12-28',
      tags: ['facility', 'equipment', 'storage']
    },
    { 
      id: 11, 
      url: 'https://images.unsplash.com/photo-1582750433449-648ed127bb54?w-800&q=80', 
      title: 'Office Reception', 
      category: 'facility',
      description: 'Our welcoming reception area in Haridwar',
      date: '2023-12-25',
      tags: ['office', 'reception', 'facility']
    },
    { 
      id: 12, 
      url: 'https://images.unsplash.com/photo-1551601651-2a8555f1a136?w-800&q=80', 
      title: 'Emergency Response Center', 
      category: 'facility',
      description: '24/7 emergency response and coordination center',
      date: '2023-12-20',
      tags: ['emergency', 'response', 'center']
    },
    
    // Success Stories
    { 
      id: 13, 
      url: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?w-800&q=80', 
      title: 'Patient Recovery Success', 
      category: 'stories',
      description: 'Celebrating successful recovery of Mr. Sharma after 3 months of home care',
      date: '2023-12-15',
      tags: ['recovery', 'success', 'patient-story']
    },
    { 
      id: 14, 
      url: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w-800&q=80', 
      title: 'Community Health Camp', 
      category: 'events',
      description: 'Free health checkup camp organized in Haridwar community',
      date: '2023-12-10',
      tags: ['community', 'health-camp', 'outreach']
    },
    { 
      id: 15, 
      url: 'https://images.unsplash.com/photo-1582750433449-648ed127bb54?w-800&q=80', 
      title: 'Award Ceremony', 
      category: 'events',
      description: 'Recognized as Best Home Homecare Service Provider 2023',
      date: '2023-12-05',
      tags: ['award', 'recognition', 'achievement']
    },
    { 
      id: 16, 
      url: 'https://images.unsplash.com/photo-1551601651-2a8555f1a136?w-800&q=80', 
      title: 'Team Celebration', 
      category: 'team',
      description: 'Celebrating 500+ successful home care cases',
      date: '2023-11-30',
      tags: ['celebration', 'team', 'milestone']
    },
  ];

  // Categories
  const categories = [
    { id: 'all', name: 'All Photos', icon: <FaImages />, count: galleryImages.length },
    { id: 'services', name: 'Our Services', icon: <FaHandsHelping />, count: galleryImages.filter(img => img.category === 'services').length },
    { id: 'team', name: 'Our Team', icon: <FaUserMd />, count: galleryImages.filter(img => img.category === 'team').length },
    { id: 'equipment', name: 'Medical Equipment', icon: <FaHome />, count: galleryImages.filter(img => img.category === 'equipment').length },
    { id: 'facility', name: 'Our Facility', icon: <FaHome />, count: galleryImages.filter(img => img.category === 'facility').length },
    { id: 'stories', name: 'Success Stories', icon: <FaHeart />, count: galleryImages.filter(img => img.category === 'stories').length },
    { id: 'events', name: 'Events & Camps', icon: <FaAmbulance />, count: galleryImages.filter(img => img.category === 'events').length },
  ];

  // Filter images based on category and search
  const filteredImages = galleryImages.filter(image => {
    const matchesCategory = selectedCategory === 'all' || image.category === selectedCategory;
    const matchesSearch = searchTerm === '' || 
      image.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      image.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
      image.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()));
    return matchesCategory && matchesSearch;
  });

  // Handle image click
  const handleImageClick = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden'; // Prevent scrolling
  };

  // Close modal
  const closeModal = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto'; // Restore scrolling
  };

  // Navigate to next/previous image
  const navigateImage = (direction) => {
    if (!selectedImage) return;
    
    const currentIndex = filteredImages.findIndex(img => img.id === selectedImage.id);
    let newIndex;
    
    if (direction === 'next') {
      newIndex = (currentIndex + 1) % filteredImages.length;
    } else {
      newIndex = (currentIndex - 1 + filteredImages.length) % filteredImages.length;
    }
    
    setSelectedImage(filteredImages[newIndex]);
  };

  // Toggle favorite
  const toggleFavorite = (imageId) => {
    const newFavorites = new Set(favorites);
    if (newFavorites.has(imageId)) {
      newFavorites.delete(imageId);
    } else {
      newFavorites.add(imageId);
    }
    setFavorites(newFavorites);
  };

  // Handle keyboard navigation
  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedImage) return;
      
      if (e.key === 'Escape') {
        closeModal();
      } else if (e.key === 'ArrowRight') {
        navigateImage('next');
      } else if (e.key === 'ArrowLeft') {
        navigateImage('prev');
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage]);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-health-blue to-health-green text-white">
        <div className="container mx-auto px-4 py-16 md:py-24">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 font-poppins">
              Homecare Gallery
            </h1>
            <p className="text-xl mb-8 opacity-90">
              A visual journey through our services, team, and success stories in Haridwar
            </p>
            <div className="flex flex-col md:flex-row gap-4 justify-center">
              <div className="relative max-w-md mx-auto md:mx-0">
                <input
                  type="text"
                  placeholder="Search photos by service, team, or tags..."
                  className="w-full px-6 py-4 rounded-full text-gray-800 focus:outline-none focus:ring-2 focus:ring-health-blue pl-14"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <FaSearch className="absolute left-6 top-1/2 transform -translate-y-1/2 text-gray-400 text-xl" />
              </div>
              <button className="px-8 py-4 bg-white text-health-blue rounded-full font-bold hover:bg-blue-50 transition-colors flex items-center justify-center">
                <FaFilter className="mr-2" />
                Filter
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Categories */}
      <div className="bg-white shadow-sm">
        <div className="container mx-auto px-4">
          <div className="flex overflow-x-auto py-4 gap-2 hide-scrollbar">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`flex items-center space-x-2 px-6 py-3 rounded-full whitespace-nowrap transition-all ${
                  selectedCategory === category.id
                    ? 'bg-health-blue text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category.icon}
                <span className="font-medium">{category.name}</span>
                <span className={`ml-2 text-sm px-2 py-1 rounded-full ${
                  selectedCategory === category.id
                    ? 'bg-blue-700'
                    : 'bg-gray-300'
                }`}>
                  {category.count}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Gallery Grid */}
      <div className="container mx-auto px-4 py-12">
        <div className="mb-8 flex justify-between items-center">
          <div>
            <h2 className="text-2xl font-bold text-gray-800 font-poppins">
              {selectedCategory === 'all' 
                ? 'All Home Care Photos' 
                : categories.find(c => c.id === selectedCategory)?.name}
            </h2>
            <p className="text-gray-600">
              {filteredImages.length} {filteredImages.length === 1 ? 'photo' : 'photos'} found
            </p>
          </div>
          <div className="text-sm text-gray-500">
            Click on any photo to view details
          </div>
        </div>

        {filteredImages.length === 0 ? (
          <div className="text-center py-20">
            <div className="text-gray-400 text-6xl mb-6">📷</div>
            <h3 className="text-2xl font-bold text-gray-700 mb-4">No photos found</h3>
            <p className="text-gray-600 max-w-md mx-auto">
              Try a different search term or category to see our Home Care gallery
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {filteredImages.map((image) => (
              <div
                key={image.id}
                className="group relative bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
                onClick={() => handleImageClick(image)}
              >
                {/* Image */}
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={image.url}
                    alt={image.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  
                  {/* Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                    <div className="text-white">
                      <h3 className="font-bold text-lg mb-1">{image.title}</h3>
                      <p className="text-sm opacity-90 truncate">{image.description}</p>
                    </div>
                  </div>
                  
                  {/* Favorite Button */}
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleFavorite(image.id);
                    }}
                    className="absolute top-4 right-4 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center text-xl hover:bg-white transition-colors"
                  >
                    <FaHeart className={favorites.has(image.id) ? 'text-red-500' : 'text-gray-400'} />
                  </button>
                  
                  {/* Category Badge */}
                  <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-sm font-semibold">
                    {categories.find(c => c.id === image.category)?.name}
                  </div>
                </div>
                
                {/* Info */}
                <div className="p-4">
                  <h3 className="font-bold text-gray-800 mb-2 truncate">{image.title}</h3>
                  <div className="flex items-center justify-between text-sm text-gray-500">
                    <span>{new Date(image.date).toLocaleDateString('en-US', { 
                      month: 'short', 
                      day: 'numeric', 
                      year: 'numeric' 
                    })}</span>
                    <div className="flex space-x-1">
                      {image.tags.slice(0, 2).map((tag, index) => (
                        <span key={index} className="bg-gray-100 px-2 py-1 rounded text-xs">
                          {tag}
                        </span>
                      ))}
                      {image.tags.length > 2 && (
                        <span className="text-xs">+{image.tags.length - 2}</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Stats Section */}
      <div className="bg-gradient-to-r from-blue-50 to-cyan-50 py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              { number: '500+', label: 'Patients Captured' },
              { number: '50+', label: 'Team Members' },
              { number: '8', label: 'Service Categories' },
              { number: '24/7', label: 'Documented' },
            ].map((stat, index) => (
              <div key={index} className="text-center p-6 bg-white rounded-xl shadow-md">
                <div className="text-3xl font-bold text-health-blue mb-2">{stat.number}</div>
                <div className="text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4">
          {/* Close Button */}
          <button
            onClick={closeModal}
            className="absolute top-6 right-6 text-white text-3xl hover:text-gray-300 z-10"
          >
            <FaTimes />
          </button>
          
          {/* Navigation Buttons */}
          <button
            onClick={() => navigateImage('prev')}
            className="absolute left-6 top-1/2 transform -translate-y-1/2 text-white text-3xl hover:text-gray-300 z-10"
          >
            <FaArrowLeft />
          </button>
          
          <button
            onClick={() => navigateImage('next')}
            className="absolute right-6 top-1/2 transform -translate-y-1/2 text-white text-3xl hover:text-gray-300 z-10"
          >
            <FaArrowRight />
          </button>
          
          {/* Modal Content */}
          <div className="max-w-6xl w-full max-h-[90vh] overflow-y-auto bg-white rounded-2xl">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              {/* Image */}
              <div className="relative h-[60vh] lg:h-auto">
                <img
                  src={selectedImage.url}
                  alt={selectedImage.title}
                  className="w-full h-full object-contain lg:object-cover"
                />
                
                {/* Image Actions */}
                <div className="absolute bottom-4 left-4 right-4 flex justify-between">
                  <button className="bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full flex items-center space-x-2 hover:bg-white">
                    <FaDownload />
                    <span>Download</span>
                  </button>
                  <button className="bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full flex items-center space-x-2 hover:bg-white">
                    <FaShareAlt />
                    <span>Share</span>
                  </button>
                  <button 
                    onClick={() => toggleFavorite(selectedImage.id)}
                    className="bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full flex items-center space-x-2 hover:bg-white"
                  >
                    <FaHeart className={favorites.has(selectedImage.id) ? 'text-red-500' : ''} />
                    <span>Favorite</span>
                  </button>
                </div>
              </div>
              
              {/* Details */}
              <div className="p-8">
                <div className="mb-6">
                  <span className="inline-block bg-blue-100 text-health-blue px-4 py-1 rounded-full text-sm font-semibold mb-4">
                    {categories.find(c => c.id === selectedImage.category)?.name}
                  </span>
                  <h2 className="text-3xl font-bold text-gray-800 mb-4">{selectedImage.title}</h2>
                  <p className="text-gray-600 text-lg mb-6">{selectedImage.description}</p>
                </div>
                
                {/* Info Grid */}
                <div className="grid grid-cols-2 gap-4 mb-8">
                  <div>
                    <h4 className="font-semibold text-gray-700 mb-2">Date Added</h4>
                    <p className="text-gray-600">
                      {new Date(selectedImage.date).toLocaleDateString('en-US', {
                        weekday: 'long',
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-700 mb-2">Category</h4>
                    <p className="text-gray-600 capitalize">{selectedImage.category}</p>
                  </div>
                </div>
                
                {/* Tags */}
                <div className="mb-8">
                  <h4 className="font-semibold text-gray-700 mb-3">Tags</h4>
                  <div className="flex flex-wrap gap-2">
                    {selectedImage.tags.map((tag, index) => (
                      <span
                        key={index}
                        className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm"
                      >
                        #{tag}
                      </span>
                    ))}
                  </div>
                </div>
                
                {/* Related Services */}
                <div>
                  <h4 className="font-semibold text-gray-700 mb-4">Related Services</h4>
                  <div className="flex flex-wrap gap-3">
                    <a 
                      href="/services/home-nursing" 
                      className="bg-blue-50 text-health-blue px-4 py-2 rounded-lg hover:bg-blue-100"
                    >
                      Home Nursing
                    </a>
                    <a 
                      href="/services/elderly-care" 
                      className="bg-green-50 text-green-700 px-4 py-2 rounded-lg hover:bg-green-100"
                    >
                      Elderly Care
                    </a>
                    <a 
                      href="/services/physiotherapy" 
                      className="bg-purple-50 text-purple-700 px-4 py-2 rounded-lg hover:bg-purple-100"
                    >
                      Physiotherapy
                    </a>
                  </div>
                </div>
                
                {/* CTA */}
                <div className="mt-12 pt-8 border-t border-gray-200">
                  <p className="text-gray-600 mb-6">
                    Interested in this service or have questions about our Home Care offerings?
                  </p>
                  <div className="flex flex-col sm:flex-row gap-4">
                    <a
                      href={`https://wa.me/918266958207?text=I'm interested in ${selectedImage.title} service`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-green-500 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-600 flex items-center justify-center"
                    >
                      💬 WhatsApp Inquiry
                    </a>
                    <a
                      href="tel:+918266958207"
                      className="bg-health-blue text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 flex items-center justify-center"
                    >
                      📞 Call for Details
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Counter */}
          <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 text-white bg-black/50 px-4 py-2 rounded-full">
            {filteredImages.findIndex(img => img.id === selectedImage.id) + 1} / {filteredImages.length}
          </div>
        </div>
      )}

      {/* Call to Action */}
      <div className="bg-gradient-to-r from-health-blue to-health-green text-white">
        <div className="container mx-auto px-4 py-16 text-center">
          <h2 className="text-3xl font-bold mb-6 font-poppins">
            Want to Feature Your Home Care Story?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto opacity-90">
            Share your experience with Lerito Home Care and inspire others in our community
          </p>
          <div className="flex flex-col md:flex-row gap-4 justify-center">
            <a
              href="/contact"
              className="bg-white text-health-blue px-8 py-4 rounded-full font-bold hover:bg-blue-50 transition-colors"
            >
              Share Your Story
            </a>
            <a
              href="https://wa.me/918266958207"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 text-white px-8 py-4 rounded-full font-bold hover:bg-green-600 transition-colors"
            >
              Send Photos via WhatsApp
            </a>
          </div>
        </div>
      </div>

      {/* Custom CSS */}
      <style jsx>{`
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
};

export default Gallery;